/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Per-frame metadata recorded during a multi-frame RealSense capture.
 * 
 * Filenames aren't stored — they follow the
 * `realsense_{color|depth_raw|depth_vis}_{frame_index:02d}.{jpg|png}`
 * convention the device writes. Ingestion derives them from `frame_index`.
 * @export
 * @interface FrameMetadata
 */
export interface FrameMetadata {
    [key: string]: any | any;
    /**
     * 
     */
    frameIndex: number;
    /**
     * 
     */
    captureTimestamp: number;
}

/**
 * Check if a given object implements the FrameMetadata interface.
 */
export function instanceOfFrameMetadata(value: object): value is FrameMetadata {
    if ((!('frameIndex' in (value as Record<string, any>)) && !('frame_index' in (value as Record<string, any>))) || ((value as Record<string, any>)['frameIndex'] === undefined && (value as Record<string, any>)['frame_index'] === undefined)) return false;
    if ((!('captureTimestamp' in (value as Record<string, any>)) && !('capture_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureTimestamp'] === undefined && (value as Record<string, any>)['capture_timestamp'] === undefined)) return false;
    return true;
}

export function FrameMetadataFromJSON(json: any): FrameMetadata {
    return FrameMetadataFromJSONTyped(json, false);
}

export function FrameMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrameMetadata {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'frameIndex': json['frame_index'],
        'captureTimestamp': json['capture_timestamp'],
    };
}

export function FrameMetadataToJSON(json: any): FrameMetadata {
    return FrameMetadataToJSONTyped(json, false);
}

export function FrameMetadataToJSONTyped(value?: FrameMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'frame_index': value['frameIndex'],
        'capture_timestamp': value['captureTimestamp'],
    };
}

